const NAME = "SPECIALIZATIONS";

export default NAME;
